import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tb-detail-banner" }
const _hoisted_2 = { class: "tb-wrap" }
const _hoisted_3 = ["src"]

import { computed } from 'vue';
	import { useStore } from 'vuex';
	import { get360DefaultNum, get360Images, getDemoImage } from '@/helpers';
	import { IStoreState } from '@/types';
	import ThreeSixtyBanner from '@/components/ThreeSixtyBanner.vue';
	import { EImageIntExtSizes } from '@/enums';

	
export default /*#__PURE__*/_defineComponent({
  name: 'DetailBanner',
  setup(__props) {

	const store = useStore<IStoreState>();
	const screenSize = computed(() => store.state.DetailApp.screenSize);

	const images360 = computed((): Array<string> => get360Images(store.state.DetailApp.images.Path_360, screenSize.value));
	const images360DefaultNum = computed(() => get360DefaultNum(images360.value, store.state.DetailApp.images.DefaultFrame));
	const non360Image = computed((): string => {
		const di = store.state.DetailApp.demoImages.length ? getDemoImage(store.state.DetailApp.demoImages[0], 1920) : '';
		return store.state.DetailApp.images.DefaultFrame || di;
	});
	// const images360Height = computed(() => {
	// 	return undefined;// store.state.DetailApp.vehicle.VehicleLine.includes('Coaster') ? null : 34
	// });

	const handle360Start = (): void => {
		const dataLayer = (window as any).dataLayer || [];
		dataLayer.push({
			event: "click_nvi_explore_3d"
		});
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(images360).length)
        ? (_openBlock(), _createBlock(ThreeSixtyBanner, {
            key: 0,
            images: _unref(images360),
            defaultImage: _unref(images360DefaultNum),
            scrollSensitivity: 3,
            activateOnHover: false,
            only180: true,
            onStarted: handle360Start
          }, null, 8, ["images", "defaultImage"]))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _unref(non360Image),
            alt: ""
          }, null, 8, _hoisted_3))
    ])
  ]))
}
}

})